import { render, staticRenderFns } from "./shopItem.vue?vue&type=template&id=c49650bc&scoped=true&"
import script from "./shopItem.vue?vue&type=script&lang=js&"
export * from "./shopItem.vue?vue&type=script&lang=js&"
import style0 from "./shopItem.vue?vue&type=style&index=0&id=c49650bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49650bc",
  null
  
)

export default component.exports